import { useState, useCallback } from 'react'
import { aiTranscribe, AITranscribeResult } from '../apis/prescription'

type UseAITranscribeReturn = {
  result: AITranscribeResult | null
  isLoading: boolean
  error: string
  transcribe: () => Promise<void>
  reset: () => void
}

export const useAITranscribe = (
  ocrRequestEventId: string | undefined
): UseAITranscribeReturn => {
  const [result, setResult] = useState<AITranscribeResult | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const transcribe = useCallback(async () => {
    if (!ocrRequestEventId) return
    setIsLoading(true)
    setError('')
    try {
      const response = await aiTranscribe(ocrRequestEventId)
      setResult(response.data)
    } catch {
      setError('AI書き起こしに失敗しました。再度お試しください。')
    } finally {
      setIsLoading(false)
    }
  }, [ocrRequestEventId])

  const reset = useCallback(() => {
    setResult(null)
    setError('')
  }, [])

  return { result, isLoading, error, transcribe, reset }
}
